import React from 'react';
import { MapPin, MessageCircle, Mail, Clock, Instagram, Star, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
const WHATSAPP_URL = 'https://wa.me/447345197820';
const TELEGRAM_URL = 'https://t.me/dentico_clinic';
const INSTAGRAM_URL = 'https://instagram.com/dentico_clinic';
const LEAVE_REVIEW_URL = 'https://g.page/r/CUmhstMLWUqlEBM/review';
function TelegramIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-128">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-129" />
    </svg>;
}
export function Footer() {
  const {
    t,
    lang
  } = useTranslation();
  const leaveReviewText = lang === 'en' ? 'Leave a Review' : lang === 'ua' ? 'Залишити відгук' : lang === 'ro' ? 'Lăsați o recenzie' : 'Оставить отзыв';
  return <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800" data-id="element-130">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-132">
          {/* Location */}
          <div className="space-y-4" data-id="element-133">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-134">
              {t('footer.location')}
            </h3>
            <div className="flex items-start gap-3" data-id="element-135">
              <MapPin className="w-5 h-5 text-teal-500 mt-1 shrink-0" data-id="element-136" />
              <div data-id="element-137">
                <a href="https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors" data-id="element-138">
                  <p className="text-gray-300" data-id="element-139">{t('footer.address')}</p>
                  <p className="text-gray-400" data-id="element-140">Angel, Islington</p>
                </a>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4" data-id="element-141">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-142">
              {t('footer.contact')}
            </h3>
            <div className="space-y-3" data-id="element-143">
              <a href="tel:+447345197820" className="flex items-center gap-3 hover:text-teal-400 transition-colors" data-id="element-144">
                <Phone className="w-5 h-5 text-teal-500" data-id="element-145" />
                <span data-id="element-146">07345 197820</span>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-teal-400 transition-colors" data-id="element-147">
                <MessageCircle className="w-5 h-5 text-teal-500" data-id="element-148" />
                <span data-id="element-149">{t('footer.whatsappChat')}</span>
              </a>
              <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-teal-400 transition-colors" data-id="element-150">
                <TelegramIcon className="w-5 h-5 text-teal-500" data-id="element-151" />
                <span data-id="element-152">Telegram</span>
              </a>
              <a href="mailto:info@denticoclinic.co.uk" className="flex items-center gap-3 hover:text-teal-400 transition-colors" data-id="element-153">
                <Mail className="w-5 h-5 text-teal-500" data-id="element-154" />
                <span data-id="element-155">info@denticoclinic.co.uk</span>
              </a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-teal-400 transition-colors" data-id="element-156">
                <Instagram className="w-5 h-5 text-teal-500" data-id="element-157" />
                <span data-id="element-158">@dentico_clinic</span>
              </a>
              <a href={LEAVE_REVIEW_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-yellow-400 transition-colors text-yellow-500" data-id="element-159">
                <Star className="w-5 h-5" data-id="element-160" />
                <span data-id="element-161">{t('reviews.leaveReview')}</span>
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="space-y-4" data-id="element-162">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-163">
              {t('footer.hours')}
            </h3>
            <div className="flex items-start gap-3" data-id="element-164">
              <Clock className="w-5 h-5 text-teal-500 mt-1 shrink-0" data-id="element-165" />
              <div className="space-y-2 text-sm w-full" data-id="element-166">
                <div className="flex justify-between gap-4" data-id="element-167">
                  <span className="text-gray-400" data-id="element-168">{t('footer.monFri')}</span>
                  <span className="text-white" data-id="element-169">10:00 - 18:00</span>
                </div>
                <div className="flex justify-between gap-4" data-id="element-170">
                  <span className="text-gray-400" data-id="element-171">{t('footer.saturday')}</span>
                  <span className="text-white" data-id="element-172">10:00 - 18:00</span>
                </div>
                <div className="flex justify-between gap-4" data-id="element-173">
                  <span className="text-gray-400" data-id="element-174">{t('footer.sunday')}</span>
                  <span className="text-white" data-id="element-175">{t('footer.closed')}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Legal */}
          <div className="space-y-4" data-id="element-176">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-177">
              {t('footer.legal.title')}
            </h3>
            <div className="flex flex-col space-y-2" data-id="element-178">
              <Link to={`/${lang}/privacy-policy`} className="hover:text-teal-400 transition-colors" data-id="element-179">
                {t('footer.legal.privacyPolicy')}
              </Link>
              <Link to={`/${lang}/cookie-policy`} className="hover:text-teal-400 transition-colors" data-id="element-180">
                {t('footer.legal.cookiePolicy')}
              </Link>
              <Link to={`/${lang}/patient-privacy-notice`} className="hover:text-teal-400 transition-colors" data-id="element-181">
                {t('footer.legal.patientPrivacy')}
              </Link>
              <span className="text-gray-500 cursor-not-allowed" data-id="element-182">
                {t('footer.legal.terms')}
              </span>
            </div>
          </div>
        </div>

        {/* Compact Contact Line */}
        <div className="border-t border-gray-800 mt-12 pt-6" data-id="element-183">
          <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-sm text-gray-400" data-id="element-184">
            <a href="https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors" data-id="element-185">
              360–364 City Rd, London EC1V 2PY
            </a>
            <span className="text-gray-600" data-id="element-186">·</span>
            <a href="tel:+447345197820" className="hover:text-teal-400 transition-colors" data-id="element-187">
              07345 197820
            </a>
            <span className="text-gray-600" data-id="element-188">·</span>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors" data-id="element-189">
              WhatsApp
            </a>
            <span className="text-gray-600" data-id="element-190">·</span>
            <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors" data-id="element-191">
              Telegram
            </a>
            <span className="text-gray-600" data-id="element-192">·</span>
            <a href="mailto:info@denticoclinic.co.uk" className="hover:text-teal-400 transition-colors" data-id="element-193">
              Email
            </a>
            <span className="text-gray-600" data-id="element-194">·</span>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors" data-id="element-195">
              Instagram
            </a>
            <span className="text-gray-600" data-id="element-196">·</span>
            <a href={LEAVE_REVIEW_URL} target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors text-yellow-500" data-id="element-197">
              {leaveReviewText}
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 text-center text-sm text-gray-500" data-id="element-198">
          <p data-id="element-199">
            &copy; {new Date().getFullYear()} Dentico Clinic.{' '}
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>;
}